
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNoteEditProposal as ObiNoteEditProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-note-edit-proposal.js';
 
 
 

 
 export const ObiNoteEditProposal = createComponent({
   react: React,
   tagName: 'obi-note-edit-proposal',
   elementClass: ObiNoteEditProposalElement,
   events: {
     
   }
  });
 
 